//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';
// import { map, filter, cloneDeep } from "lodash"

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const galleryInitial = [];

export const one_game_category = (state = galleryInitial, action) => {
    switch (action.type) {
        case ActionTypes.one_game_category.create_one_game_category:
            return [action.payload, ...state];
        case ActionTypes.one_game_category.list_one_game_category:
             return action.payload;
        case ActionTypes.one_game_category.update_one_game_category:
            // return map(state, dt => {
            //     if (dt.id === action.payload.id) {
            //         return action.payload;
            //     }
            //     return dt;
            // })
            return;
        case ActionTypes.one_game_category.delete_one_game_category:
            //  return filter(state[0]?.meta_data,dt=>dt.id!==action.payload)
            return;
        default:
            return state;
    }
};
